import {TypeImpl} from './TypeImpl';
import {Type} from './Type';
import {DateFormat} from "../../DateFormat";
import {Helper} from "../../Helper";

export class TypeDate extends TypeImpl implements Type {

    private dateEl: HTMLInputElement;

    public execute(): void {
        if (!this.isSupportInputType('date')) {
            return;
        }
        if (!this.isDevace()) {
            return;
        }

        let dateEl = this.createDateElement();
        this.setDate(this.target.value, dateEl);
        Helper.insertAfter(dateEl, this.target);

        this.target.className = 'device_type_date_input';
    }

    private setDate(date: string, dateEl: HTMLInputElement): void {
        if (date.indexOf('.') + 1) {
            dateEl.value = this.formatDate(date);
        } else {
            dateEl.value = date;
        }
    }

    private createDateElement(): HTMLInputElement {
        this.dateEl = document.createElement('input');
        this.dateEl.setAttribute("inputmode", "numeric");
        this.dateEl.type = 'date';
        this.changeDate(this.dateEl);
        return this.dateEl;
    }

    private changeDate(dateEl: HTMLInputElement): void {
        dateEl.addEventListener('change', (e: Event) => {
            let target = (e.target as HTMLInputElement);
            let date = new Date(target.value);
            this.target.value = DateFormat.formatDateRus(date);
        }, false);
    }

    private formatDate(date: string): string {
        let dd = date[0] + '' + date[1];
        let mm = date[3] + '' + date[4];
        let yy = date[6] + '' + date[7] + '' + date[8] + '' + date[9];
        return yy + '-' + mm + '-' + dd;
    }

    private isDevace() {
        return document.documentElement.clientWidth <= 640;
    }
}
